import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum ScheduledProductSeriesSubscriptionFields {
    STUDENT = 'student',
    SERIES = 'series',
    START_DATE = 'startDate',
    LAST_SHIPMENT_DATE = 'lastShipmentDate',
    NEXT_SHIPMENT_DATE = 'nextShipmentDate',
    IS_PAUSED = 'isPaused',
    ERROR_MESSAGE = 'errorMessage',
    AUTO_INCREMENT = 'autoIncrement',
    CYCLE = 'cycle',
    NEXT_INDEX = 'nextIndex',
    LAST_ITEM = 'lastItem',
    NEXT_ITEM = 'nextItem',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace ScheduledProductSeriesSubscriptionFields {
    type Data = {
        text: string;
        readOnly?: true;
        updateOnly?: true;
    }

    export const Record: Record<ScheduledProductSeriesSubscriptionFields, Data> = {
        [ScheduledProductSeriesSubscriptionFields.STUDENT]: {
            text: 'Schüler:in',
            readOnly: true,
        },
        [ScheduledProductSeriesSubscriptionFields.SERIES]: {
            text: 'Produktreihe',
            readOnly: true,
        },
        [ScheduledProductSeriesSubscriptionFields.START_DATE]: {
            text: 'Startdatum',
            readOnly: true,
        },
        [ScheduledProductSeriesSubscriptionFields.LAST_SHIPMENT_DATE]: {
            text: 'Letzter Versand',
            readOnly: true,
        },
        [ScheduledProductSeriesSubscriptionFields.NEXT_SHIPMENT_DATE]: {
            text: 'Nächster Versand',
        },
        [ScheduledProductSeriesSubscriptionFields.IS_PAUSED]: {
            text: 'Pausiert',
        },
        [ScheduledProductSeriesSubscriptionFields.ERROR_MESSAGE]: {
            text: 'Fehlermeldung',
            readOnly: true,
        },
        [ScheduledProductSeriesSubscriptionFields.AUTO_INCREMENT]: {
            text: 'Automatische Ausführung',
            readOnly: true,
        },
        [ScheduledProductSeriesSubscriptionFields.CYCLE]: {
            text: 'Rechnungslauf',
            readOnly: true,
        },
        [ScheduledProductSeriesSubscriptionFields.NEXT_INDEX]: {
            text: 'Index des nächsten Elements',
            readOnly: true,
        },
        [ScheduledProductSeriesSubscriptionFields.LAST_ITEM]: {
            text: 'ID des zuletzt versandten Elements',
            readOnly: true,
        },
        [ScheduledProductSeriesSubscriptionFields.NEXT_ITEM]: {
            text: 'ID des nächsten Elements',
            readOnly: true,
        },
        [ScheduledProductSeriesSubscriptionFields.CREATED_AT]: {
            text: 'Erzeugungsdatum',
            readOnly: true,
        },
        [ScheduledProductSeriesSubscriptionFields.UPDATED_AT]: {
            text: 'Änderungsdatum',
            readOnly: true,
        },
    };

    export const Items = mapRecordToItems(Record);
}
